import React, { useState, useEffect, useCallback } from 'react';
import toast from 'react-hot-toast';
import api from '../utils/api';

const C = {
  bg: '#0a0a0a', surface: '#141414', surface2: '#1a1a1a',
  border: '#222', text: '#fff', textMuted: '#777', textSub: '#aaa',
  accent: '#d4f535', green: '#4ade80', orange: '#fb923c',
  red: '#f87171', purple: '#a78bfa', blue: '#60a5fa',
};

const Icon = ({ name, size = 15, color = 'currentColor' }) => {
  const icons = {
    users: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
    folder: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>,
    plus: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
    search: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
    edit: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
    copy: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>,
    key: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>,
    clock: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
    ban: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>,
    smartphone: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>,
    refresh: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>,
    trash: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>,
    download: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
    eye: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>,
    eyeOff: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>,
    mail: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
    chevronDown: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>,
    chevronUp: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="18 15 12 9 6 15"/></svg>,
    more: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>,
    shield: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
    check: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
    save: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>,
    x: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  };
  return icons[name] || null;
};

const inputStyle = {
  width: '100%', padding: '11px 14px', borderRadius: 8,
  border: `1px solid ${C.border}`, fontSize: 14, outline: 'none',
  background: C.surface2, color: C.text, boxSizing: 'border-box',
};

const btnStyle = (variant = 'default') => ({
  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7,
  padding: '9px 14px', borderRadius: 8, fontSize: 12, fontWeight: 600,
  cursor: 'pointer', transition: 'all 0.15s',
  ...(variant === 'accent'  ? { background: C.accent,   color: '#0a0a0a', border: 'none' } :
      variant === 'danger'  ? { background: 'transparent', color: C.red,    border: `1px solid #3f1515` } :
      variant === 'ghost'   ? { background: C.surface2,  color: C.textSub,  border: `1px solid ${C.border}` } :
      variant === 'active'  ? { background: C.accent+'22', color: C.accent, border: `1px solid ${C.accent}44` } :
                              { background: C.surface2,  color: C.text,     border: `1px solid ${C.border}` }),
});

const modalStyle = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
  zIndex: 9999, display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
};
const modalInner = {
  background: C.surface, width: '100%', maxWidth: 480,
  borderRadius: '16px 16px 0 0', padding: 24, maxHeight: '90vh', overflowY: 'auto',
};

function FolderModal({ folder, onClose, onSave }) {
  const [form, setForm] = useState({ name: folder?.name || '', color: folder?.color || '#d4f535' });
  const [loading, setLoading] = useState(false);
  const colors = ['#d4f535','#4ade80','#60a5fa','#a78bfa','#fb923c','#f87171','#34d399','#f472b6'];
  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      if (folder?.id) await api.put('/folders/' + folder.id, form);
      else await api.post('/folders', form);
      toast.success(folder?.id ? 'Dossier modifié' : 'Dossier créé'); onSave();
    } catch (err) { toast.error(err.response?.data?.error || 'Erreur'); }
    finally { setLoading(false); }
  };
  return (
    <div onClick={e => e.target === e.currentTarget && onClose()} style={modalStyle}>
      <div style={modalInner}>
        <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:20 }}>
          <h2 style={{ fontSize:16,fontWeight:800,color:C.text,margin:0 }}>{folder?.id ? 'Modifier le dossier' : 'Nouveau dossier'}</h2>
          <button onClick={onClose} style={{ background:C.surface2,border:`1px solid ${C.border}`,borderRadius:8,width:32,height:32,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center' }}><Icon name="x" size={14} color={C.textSub}/></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom:16 }}>
            <label style={{ display:'block',fontSize:11,fontWeight:600,color:C.textSub,marginBottom:6,textTransform:'uppercase',letterSpacing:1 }}>Nom du dossier</label>
            <input value={form.name} required onChange={e => setForm(f=>({...f,name:e.target.value}))} placeholder="Ex: Administratif" style={inputStyle}/>
          </div>
          <div style={{ marginBottom:20 }}>
            <label style={{ display:'block',fontSize:11,fontWeight:600,color:C.textSub,marginBottom:8,textTransform:'uppercase',letterSpacing:1 }}>Couleur</label>
            <div style={{ display:'flex',gap:8,flexWrap:'wrap' }}>
              {colors.map(c => (
                <div key={c} onClick={() => setForm(f=>({...f,color:c}))}
                  style={{ width:28,height:28,borderRadius:6,background:c,cursor:'pointer',border:form.color===c?`2px solid ${C.text}`:`2px solid transparent`,display:'flex',alignItems:'center',justifyContent:'center' }}>
                  {form.color===c && <Icon name="check" size={14} color="#0a0a0a"/>}
                </div>
              ))}
            </div>
          </div>
          <div style={{ display:'flex',gap:8 }}>
            <button type="button" onClick={onClose} style={{...btnStyle('ghost'),flex:1}}>Annuler</button>
            <button type="submit" disabled={loading} style={{...btnStyle('accent'),flex:1,opacity:loading?0.6:1}}>
              <Icon name="save" size={14} color="#0a0a0a"/>{loading ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function MemberModal({ member, folders, onClose, onSave }) {
  const [form, setForm] = useState(member ? {
    name: member.name, email: member.email,
    folder_id: member.folder_id || '', assignedVersion: member.version
  } : { name: '', email: '', folder_id: '', assignedVersion: 'A' });
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const payload = { ...form, folder_id: form.folder_id || null, group: 'general' };
      if (member?.id) await api.put('/members/' + member.id, payload);
      else await api.post('/members', payload);
      toast.success(member?.id ? 'Membre mis à jour' : 'Membre créé'); onSave();
    } catch (err) { toast.error(err.response?.data?.error || 'Erreur'); }
    finally { setLoading(false); }
  };
  return (
    <div onClick={e => e.target === e.currentTarget && onClose()} style={modalStyle}>
      <div style={modalInner}>
        <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:20 }}>
          <h2 style={{ fontSize:16,fontWeight:800,color:C.text,margin:0 }}>{member?.id ? 'Modifier' : 'Ajouter un membre'}</h2>
          <button onClick={onClose} style={{ background:C.surface2,border:`1px solid ${C.border}`,borderRadius:8,width:32,height:32,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center' }}><Icon name="x" size={14} color={C.textSub}/></button>
        </div>
        <form onSubmit={handleSubmit}>
          {[{k:'name',l:'Nom complet',t:'text',p:'Jean Dupont'},{k:'email',l:'Email',t:'email',p:'jean@exemple.com'}].map(({k,l,t,p}) => (
            <div key={k} style={{ marginBottom:14 }}>
              <label style={{ display:'block',fontSize:11,fontWeight:600,color:C.textSub,marginBottom:6,textTransform:'uppercase',letterSpacing:1 }}>{l}</label>
              <input type={t} value={form[k]||''} placeholder={p} required onChange={e => setForm(f=>({...f,[k]:e.target.value}))} style={inputStyle}/>
            </div>
          ))}
          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:20 }}>
            <div>
              <label style={{ display:'block',fontSize:11,fontWeight:600,color:C.textSub,marginBottom:6,textTransform:'uppercase',letterSpacing:1 }}>Dossier</label>
              <select value={form.folder_id} onChange={e => setForm(f=>({...f,folder_id:e.target.value}))}
                style={{...inputStyle,cursor:'pointer'}}>
                <option value="">Sans dossier</option>
                {folders.map(f => <option key={f.id} value={f.id}>{f.name}</option>)}
              </select>
            </div>
            <div>
              <label style={{ display:'block',fontSize:11,fontWeight:600,color:C.textSub,marginBottom:6,textTransform:'uppercase',letterSpacing:1 }}>Version PDF</label>
              <select value={form.assignedVersion} onChange={e => setForm(f=>({...f,assignedVersion:e.target.value}))}
                style={{...inputStyle,cursor:'pointer'}}>
                {['A','B','C'].map(v => <option key={v} value={v}>Version {v}</option>)}
              </select>
            </div>
          </div>
          <div style={{ display:'flex',gap:8 }}>
            <button type="button" onClick={onClose} style={{...btnStyle('ghost'),flex:1}}>Annuler</button>
            <button type="submit" disabled={loading} style={{...btnStyle('accent'),flex:1,opacity:loading?0.6:1}}>
              <Icon name="save" size={14} color="#0a0a0a"/>{loading ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function getReadingStatus(totalReadingTime, totalOpens) {
  const t = totalReadingTime || 0;
  if (totalOpens === 0 || t === 0) return { label: 'Non lu', color: C.textSub };
  if (t < 30)  return { label: 'Lecture rapide',    color: C.red };
  if (t < 120) return { label: 'Lecture partielle', color: C.orange };
  return { label: 'Lecture complète', color: C.green };
}

function MemberCard({ m, onEdit, onDelete, onCopy, onRegen, onPin, onDownload, onReset, onOtpDuration }) {
  const [manageOpen, setManageOpen] = useState(false);
  const reading = getReadingStatus(m.total_reading_time, m.total_opens);
  const t = m.total_reading_time || 0;
  const timeLabel = t === 0 ? '—' : t < 60 ? t + 's' : Math.floor(t/60) + 'min ' + (t%60>0?t%60+'s':'');
  const initials = m.name?.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2) || '?';

  return (
    <div style={{ background: C.surface, borderRadius: 12, border: `1px solid ${C.border}`, overflow: 'hidden' }}>
      {/* Header card */}
      <div style={{ padding: '14px 16px', borderBottom: `1px solid ${C.border}` }}>
        <div style={{ display:'flex', alignItems:'flex-start', gap:12 }}>
          <div style={{ width:44, height:44, borderRadius:10, background: m.folder_color ? m.folder_color+'33' : C.accent+'22', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:900, fontSize:14, color: m.folder_color || C.accent, flexShrink:0 }}>
            {initials}
          </div>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <div style={{ fontWeight:700, fontSize:15, color:C.text }}>{m.name}</div>
              <button onClick={() => onEdit(m)} style={{ background:'none', border:'none', cursor:'pointer', padding:4 }}>
                <Icon name="edit" size={14} color={C.textSub}/>
              </button>
            </div>
            <div style={{ fontSize:11, color:C.textMuted, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{m.email}</div>
            <div style={{ display:'flex', gap:6, marginTop:6, flexWrap:'wrap', alignItems:'center' }}>
              {m.folder_name && (
                <span style={{ background: (m.folder_color||C.accent)+'22', color: m.folder_color||C.accent, borderRadius:4, padding:'2px 7px', fontSize:10, fontWeight:700 }}>
                  {m.folder_name}
                </span>
              )}
              <span style={{ background: C.surface2, color:C.textSub, borderRadius:4, padding:'2px 7px', fontSize:10, fontWeight:600, border:`1px solid ${C.border}` }}>v{m.version}</span>
              {m.pin_code && (
                <span style={{ background: C.accent+'18', color:C.accent, borderRadius:4, padding:'2px 7px', fontSize:10, fontWeight:700, display:'flex', alignItems:'center', gap:3 }}>
                  <Icon name="key" size={9} color={C.accent}/> PIN
                </span>
              )}
              <span style={{ color: reading.color, fontSize:10, fontWeight:700, display:'flex', alignItems:'center', gap:3 }}>
                <span style={{ width:6, height:6, borderRadius:'50%', background: reading.color, display:'inline-block' }}/>
                {reading.label}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', borderBottom:`1px solid ${C.border}` }}>
        {[
          { icon:'eye',   label:'Ouvertures', value: m.total_opens||0, color: C.purple },
          { icon:'download', label:'Téléchargé', value: m.has_downloaded ? 'Oui' : 'Non', color: m.has_downloaded ? C.red : C.green },
          { icon:'clock',  label:'Lecture',    value: timeLabel, color: C.accent },
        ].map((s,i) => (
          <div key={i} style={{ padding:'12px 8px', textAlign:'center', borderRight: i<2?`1px solid ${C.border}`:'none' }}>
            <Icon name={s.icon} size={13} color={C.textMuted}/>
            <div style={{ fontSize:15, fontWeight:800, color:s.color, marginTop:4, lineHeight:1 }}>{s.value}</div>
            <div style={{ fontSize:9, color:C.textMuted, marginTop:3, textTransform:'uppercase', letterSpacing:0.5 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Info ligne: DL bloqué + OTP */}
      <div style={{ display:'flex', justifyContent:'space-between', padding:'8px 16px', borderBottom:`1px solid ${C.border}` }}>
        <div style={{ display:'flex', alignItems:'center', gap:5, fontSize:11, color: m.download_allowed ? C.orange : C.textMuted }}>
          <Icon name="shield" size={12} color={m.download_allowed ? C.orange : C.textMuted}/>
          {m.download_allowed ? 'Téléchargement autorisé' : 'Téléchargement bloqué'}
        </div>
        <div style={{ fontSize:11, color:C.textMuted }}>
          OTP {m.otp_duration_hours ? m.otp_duration_hours+'h' : 'Global'}
        </div>
      </div>

      {/* Actions principales */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:1, background:C.border }}>
        <button onClick={() => onCopy(m.tracking_link)} style={{...btnStyle('ghost'), borderRadius:0, border:'none', background:C.surface, padding:'11px'}}>
          <Icon name="copy" size={13} color={C.textSub}/> Copier le lien
        </button>
        <button onClick={() => setManageOpen(o=>!o)} style={{...btnStyle('ghost'), borderRadius:0, border:'none', background:C.surface2, padding:'11px'}}>
          <Icon name="more" size={13} color={C.textSub}/>
          Gérer
          {manageOpen ? <Icon name="chevronUp" size={12} color={C.textSub}/> : <Icon name="chevronDown" size={12} color={C.textSub}/>}
        </button>
      </div>

      {/* Panneau Gérer (accordion) */}
      {manageOpen && (
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, padding:12, background:C.surface2, borderTop:`1px solid ${C.border}` }}>
          <button onClick={() => onPin(m.id, m.name, m.pin_code)} style={m.pin_code ? btnStyle('active') : btnStyle('ghost')}>
            <Icon name="key" size={13} color={m.pin_code ? C.accent : C.textSub}/>
            {m.pin_code ? 'PIN actif' : 'Définir PIN'}
            {m.pin_code && <Icon name="check" size={11} color={C.accent}/>}
          </button>
          <button onClick={() => onOtpDuration(m.id, m.name, m.otp_duration_hours)} style={btnStyle('ghost')}>
            <Icon name="clock" size={13} color={C.textSub}/> OTP: {m.otp_duration_hours ? m.otp_duration_hours+'h' : 'Global'}
          </button>
          <button onClick={() => onDownload(m.id, m.name, m.download_allowed)} style={m.download_allowed ? {...btnStyle('ghost'), color:C.orange, borderColor:'#3a2000'} : btnStyle('ghost')}>
            <Icon name="ban" size={13} color={m.download_allowed ? C.orange : C.textSub}/>
            {m.download_allowed ? 'Bloquer DL' : 'Autoriser DL'}
          </button>
          <button onClick={() => onReset(m.id, m.name)} style={btnStyle('ghost')}>
            <Icon name="smartphone" size={13} color={C.textSub}/> Reset appareil
          </button>
          <button onClick={() => onRegen(m.id, m.name)} style={btnStyle('ghost')}>
            <Icon name="refresh" size={13} color={C.textSub}/> Nouveau lien
          </button>
          <button onClick={() => onDelete(m.id, m.name)} style={btnStyle('danger')}>
            <Icon name="trash" size={13} color={C.red}/> Supprimer
          </button>
        </div>
      )}
    </div>
  );
}

export default function MembersPage() {
  const [members, setMembers] = useState([]);
  const [folders, setFolders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterFolder, setFilterFolder] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editMember, setEditMember] = useState(null);
  const [showFolderModal, setShowFolderModal] = useState(false);
  const [editFolder, setEditFolder] = useState(null);
  const [showFolders, setShowFolders] = useState(false);
  const [pinModal, setPinModal] = useState(null);
  const [otpModal, setOtpModal] = useState(null);
  const [otpHours, setOtpHours] = useState('');
  const [newPin, setNewPin] = useState('');
  const [showPin, setShowPin] = useState(false);

  const fetchAll = useCallback(async () => {
    try {
      const [{ data: m }, { data: f }] = await Promise.all([api.get('/members'), api.get('/folders')]);
      setMembers(m); setFolders(f);
    } catch { toast.error('Erreur chargement'); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { fetchAll(); }, [fetchAll]);

  const handleDelete = async (id, name) => {
    if (!window.confirm('Supprimer ' + name + ' ?')) return;
    try { await api.delete('/members/' + id); toast.success('Supprimé'); fetchAll(); }
    catch { toast.error('Erreur suppression'); }
  };
  const handleDeleteFolder = async (id, name) => {
    if (!window.confirm('Supprimer le dossier "' + name + '" ?')) return;
    try { await api.delete('/folders/' + id); toast.success('Dossier supprimé'); fetchAll(); }
    catch { toast.error('Erreur'); }
  };
  const handleRegen = async (id, name) => {
    if (!window.confirm('Régénérer le lien de ' + name + ' ?')) return;
    try {
      const { data } = await api.post('/members/' + id + '/regenerate-token');
      await navigator.clipboard.writeText(data.trackingLink).catch(() => {});
      toast.success('Nouveau lien généré et copié !'); fetchAll();
    } catch { toast.error('Erreur'); }
  };
  const handleCopy = async (link) => {
    if (!link) { toast.error('Pas de lien disponible'); return; }
    try { await navigator.clipboard.writeText(link); toast.success('Lien copié !'); }
    catch { toast.error('Impossible de copier'); }
  };
  const handleDownload = async (id, name, currentAllow) => {
    if (!window.confirm((currentAllow ? 'Désactiver' : 'Autoriser') + ' le téléchargement pour ' + name + ' ?')) return;
    try {
      await api.post('/members/' + id + '/set-download', { allow: !currentAllow });
      toast.success(currentAllow ? 'Téléchargement désactivé' : 'Autorisé pour ' + name); fetchAll();
    } catch { toast.error('Erreur'); }
  };
  const handlePin = (id, name, currentPin) => { setPinModal({ id, name, currentPin }); setNewPin(''); setShowPin(false); };
  const handleOtpDuration = (id, name, currentHours) => { setOtpModal({ id, name, currentHours }); setOtpHours(currentHours || ''); };
  const handleOtpSave = async () => {
    const hours = otpHours === '' ? null : parseInt(otpHours);
    if (hours !== null && (isNaN(hours) || hours < 1)) { toast.error('Durée invalide'); return; }
    try {
      await api.post('/members/' + otpModal.id + '/set-otp-duration', { hours });
      toast.success(hours ? 'OTP: ' + hours + 'h' : 'OTP global restauré');
      setOtpModal(null); fetchAll();
    } catch { toast.error('Erreur'); }
  };
  const handleResetDevice = async (id, name) => {
    if (!window.confirm("Réinitialiser l'appareil de " + name + ' ?')) return;
    try { await api.post('/members/' + id + '/reset-device'); toast.success('Appareil réinitialisé'); fetchAll(); }
    catch { toast.error('Erreur'); }
  };
  const handlePinSave = async () => {
    if (!newPin && !pinModal?.currentPin) { toast.error('Saisissez un PIN'); return; }
    if (newPin && newPin.length < 4) { toast.error('PIN trop court (min 4)'); return; }
    try {
      await api.post('/members/' + pinModal.id + '/set-pin', { pin: newPin || pinModal.currentPin });
      toast.success('PIN mis à jour'); setPinModal(null); fetchAll();
    } catch { toast.error('Erreur'); }
  };
  const handlePinDelete = async () => {
    if (!window.confirm('Supprimer le PIN ?')) return;
    try { await api.post('/members/' + pinModal.id + '/set-pin', { pin: null }); toast.success('PIN supprimé'); setPinModal(null); fetchAll(); }
    catch { toast.error('Erreur'); }
  };
  const handlePinSendEmail = async () => {
    try { await api.post('/members/' + pinModal.id + '/send-pin-email'); toast.success('PIN envoyé par email'); }
    catch { toast.error('Erreur envoi email'); }
  };

  const filtered = members.filter(m => {
    const q = search.toLowerCase();
    return (!q || m.name?.toLowerCase().includes(q) || m.email?.toLowerCase().includes(q))
        && (!filterFolder || m.folder_id === filterFolder);
  });

  return (
    <div style={{ padding:16, background:C.bg, minHeight:'100vh' }}>
      {showModal && <MemberModal member={editMember} folders={folders} onClose={() => { setShowModal(false); setEditMember(null); }} onSave={() => { setShowModal(false); setEditMember(null); fetchAll(); }} />}
      {showFolderModal && <FolderModal folder={editFolder} onClose={() => { setShowFolderModal(false); setEditFolder(null); }} onSave={() => { setShowFolderModal(false); setEditFolder(null); fetchAll(); }} />}

      {/* Header */}
      <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16,flexWrap:'wrap',gap:10 }}>
        <div>
          <div style={{ fontSize:10,color:C.textMuted,textTransform:'uppercase',letterSpacing:1.5,marginBottom:4 }}>ESPACE DE TRAVAIL</div>
          <h1 style={{ fontSize:22,fontWeight:900,color:C.text,margin:0,letterSpacing:'-0.5px' }}>Membres</h1>
          <p style={{ color:C.textMuted,fontSize:11,marginTop:2 }}>{members.length} membre{members.length!==1?'s':''}</p>
        </div>
        <div style={{ display:'flex',gap:8 }}>
          <button onClick={() => setShowFolders(s=>!s)} style={btnStyle('ghost')}>
            <Icon name="folder" size={14} color={C.textSub}/> Dossiers ({folders.length})
          </button>
          <button onClick={() => { setEditMember(null); setShowModal(true); }} style={btnStyle('accent')}>
            <Icon name="plus" size={14} color="#0a0a0a"/> Ajouter
          </button>
        </div>
      </div>

      {/* Panneau dossiers */}
      {showFolders && (
        <div style={{ background:C.surface,borderRadius:12,border:`1px solid ${C.border}`,padding:16,marginBottom:16 }}>
          <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12 }}>
            <div style={{ display:'flex',alignItems:'center',gap:8 }}>
              <Icon name="folder" size={15} color={C.accent}/>
              <h3 style={{ fontSize:14,fontWeight:700,color:C.text,margin:0 }}>Gérer les dossiers</h3>
            </div>
            <button onClick={() => { setEditFolder(null); setShowFolderModal(true); }} style={btnStyle('accent')}>
              <Icon name="plus" size={13} color="#0a0a0a"/> Nouveau
            </button>
          </div>
          {folders.length === 0 ? (
            <p style={{ color:C.textMuted,fontSize:13,textAlign:'center',padding:'16px 0' }}>Aucun dossier — créez-en un pour organiser vos membres</p>
          ) : (
            <div style={{ display:'flex',flexDirection:'column',gap:6 }}>
              {folders.map(f => (
                <div key={f.id} style={{ display:'flex',alignItems:'center',gap:10,padding:'10px 12px',borderRadius:8,background:C.surface2,border:`1px solid ${C.border}` }}>
                  <div style={{ width:10,height:10,borderRadius:3,background:f.color,flexShrink:0 }}/>
                  <span style={{ flex:1,fontWeight:600,fontSize:13,color:C.text }}>{f.name}</span>
                  <span style={{ fontSize:11,color:C.textMuted }}>{members.filter(m=>m.folder_id===f.id).length} membre(s)</span>
                  <button onClick={() => { setEditFolder(f); setShowFolderModal(true); }} style={{...btnStyle('ghost'),padding:'5px 10px',fontSize:11}}><Icon name="edit" size={12} color={C.textSub}/></button>
                  <button onClick={() => handleDeleteFolder(f.id, f.name)} style={{...btnStyle('danger'),padding:'5px 10px',fontSize:11}}><Icon name="trash" size={12} color={C.red}/></button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Recherche + filtre */}
      <div style={{ display:'flex',gap:8,marginBottom:16,flexWrap:'wrap' }}>
        <div style={{ flex:1,minWidth:140,position:'relative',display:'flex',alignItems:'center' }}>
          <span style={{ position:'absolute',left:12 }}><Icon name="search" size={14} color={C.textMuted}/></span>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Rechercher..."
            style={{...inputStyle,paddingLeft:36}}/>
        </div>
        <select value={filterFolder} onChange={e => setFilterFolder(e.target.value)}
          style={{...inputStyle,width:'auto',cursor:'pointer',paddingRight:32}}>
          <option value="">Tous les dossiers</option>
          {folders.map(f => <option key={f.id} value={f.id}>{f.name}</option>)}
        </select>
      </div>

      {loading ? (
        <div style={{ textAlign:'center',padding:48,color:C.textMuted,display:'flex',alignItems:'center',justifyContent:'center',gap:10 }}>
          <Icon name="refresh" size={16} color={C.accent}/> Chargement...
        </div>
      ) : filtered.length === 0 ? (
        <div style={{ textAlign:'center',padding:48,background:C.surface,borderRadius:12,border:`1px solid ${C.border}` }}>
          <Icon name="users" size={36} color={C.textMuted}/>
          <p style={{ color:C.textMuted,marginTop:12 }}>Aucun membre trouvé</p>
        </div>
      ) : (
        <div style={{ display:'flex',flexDirection:'column',gap:10 }}>
          {filtered.map(m => (
            <MemberCard key={m.id} m={m}
              onEdit={m => { setEditMember(m); setShowModal(true); }}
              onDelete={handleDelete} onCopy={handleCopy} onRegen={handleRegen}
              onPin={handlePin} onDownload={handleDownload} onReset={handleResetDevice}
              onOtpDuration={handleOtpDuration}
            />
          ))}
        </div>
      )}

      {/* Modal OTP */}
      {otpModal && (
        <div style={modalStyle}>
          <div style={modalInner}>
            <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16 }}>
              <div style={{ display:'flex',alignItems:'center',gap:8 }}>
                <Icon name="clock" size={16} color={C.accent}/>
                <h2 style={{ fontSize:16,fontWeight:800,color:C.text,margin:0 }}>Durée OTP — {otpModal.name}</h2>
              </div>
              <button onClick={() => setOtpModal(null)} style={{ background:'none',border:'none',cursor:'pointer' }}><Icon name="x" size={16} color={C.textSub}/></button>
            </div>
            <div style={{ display:'flex',gap:6,flexWrap:'wrap',marginBottom:14 }}>
              {[1,6,12,24,48,72,168].map(h => (
                <button key={h} onClick={() => setOtpHours(String(h))}
                  style={otpHours===String(h) ? {...btnStyle('active'),padding:'6px 12px'} : {...btnStyle('ghost'),padding:'6px 12px'}}>
                  {h<24?h+'h':h===168?'7j':(h/24)+'j'}
                </button>
              ))}
            </div>
            <div style={{ display:'flex',gap:8,alignItems:'center',marginBottom:14 }}>
              <input type="number" value={otpHours} onChange={e => setOtpHours(e.target.value)} placeholder="Ex: 36" min={1}
                style={{...inputStyle,textAlign:'center',fontSize:18,flex:1}}/>
              <span style={{ fontSize:13,color:C.textSub }}>heures</span>
            </div>
            <div style={{ display:'flex',flexDirection:'column',gap:8 }}>
              <button onClick={handleOtpSave} style={{...btnStyle('accent'),width:'100%',padding:'12px'}}>
                <Icon name="save" size={14} color="#0a0a0a"/> Sauvegarder
              </button>
              <button onClick={() => { setOtpHours(''); handleOtpSave(); }} style={{...btnStyle('ghost'),width:'100%',padding:'12px'}}>
                <Icon name="refresh" size={14} color={C.textSub}/> Utiliser durée globale
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal PIN */}
      {pinModal && (
        <div style={modalStyle}>
          <div style={modalInner}>
            <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16 }}>
              <div style={{ display:'flex',alignItems:'center',gap:8 }}>
                <Icon name="key" size={16} color={C.accent}/>
                <h2 style={{ fontSize:16,fontWeight:800,color:C.text,margin:0 }}>PIN — {pinModal.name}</h2>
              </div>
              <button onClick={() => setPinModal(null)} style={{ background:'none',border:'none',cursor:'pointer' }}><Icon name="x" size={16} color={C.textSub}/></button>
            </div>
            {pinModal.currentPin && (
              <div style={{ background: C.accent+'15', border:`1px solid ${C.accent}33`, borderRadius:10, padding:'12px 16px', marginBottom:16 }}>
                <div style={{ fontSize:11,color:C.accent,fontWeight:600,marginBottom:4,textTransform:'uppercase',letterSpacing:1 }}>PIN actuel</div>
                <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between' }}>
                  <span style={{ fontSize:24,fontWeight:900,letterSpacing:8,color:C.text,fontFamily:'monospace' }}>{showPin?pinModal.currentPin:'••••'}</span>
                  <button onClick={() => setShowPin(s=>!s)} style={{ background:'none',border:'none',cursor:'pointer' }}>
                    <Icon name={showPin?'eyeOff':'eye'} size={18} color={C.textSub}/>
                  </button>
                </div>
              </div>
            )}
            <input type="number" value={newPin} onChange={e => setNewPin(e.target.value)} placeholder="Nouveau PIN" maxLength={10}
              style={{...inputStyle,textAlign:'center',fontSize:22,letterSpacing:8,fontFamily:'monospace',marginBottom:14}}/>
            <div style={{ display:'flex',flexDirection:'column',gap:8 }}>
              <button onClick={handlePinSave} style={{...btnStyle('accent'),width:'100%',padding:'12px'}}>
                <Icon name="save" size={14} color="#0a0a0a"/> Sauvegarder le PIN
              </button>
              <button onClick={handlePinSendEmail} style={{...btnStyle('ghost'),width:'100%',padding:'12px'}}>
                <Icon name="mail" size={14} color={C.textSub}/> Envoyer le PIN par email
              </button>
              {pinModal.currentPin && (
                <button onClick={handlePinDelete} style={{...btnStyle('danger'),width:'100%',padding:'12px'}}>
                  <Icon name="trash" size={14} color={C.red}/> Supprimer le PIN
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
